
export type ValidationWarnings = {
    [key: string]: string;
  };
  
  // "framework"
  export interface EntityValidationFn<T> {
    (entity: T): ValidationWarnings | null;
  }
  
  export function executeEntityValidators<T>(entity: T, validatorFunctions: EntityValidationFn<T>[]): ValidationWarnings | null {
    if (entity == null) {
      return null;
    }
  
    if (!validatorFunctions) {
      return null;
    }
  
    var result: ValidationWarnings = {};
  
    for (var validatorFn of validatorFunctions) {
      const singleResult = validatorFn(entity);
      Object.assign(result, singleResult);
    }
  
    if (Object.keys(result).length == 0) {
      return null;
    }
    return result;
  }
  
  export function filterValidationWarnings(fullResults: ValidationWarnings | null, errorKeys: string | string[]): ValidationWarnings {
    fullResults = fullResults || {};
    if (errorKeys == null) {
      return fullResults;
    }
    if (typeof errorKeys == 'string') {
      errorKeys = [errorKeys];
    }
    var results = {};
    for (var errorKey of errorKeys) {
      if (fullResults[errorKey] != null) {
        results[errorKey] = fullResults[errorKey];
      }
    }
    return results;
  }